import {feriadosGetDuck, feriadoCreateDuck, feriadoDeleteDuck} from './duck';

const feriadosReducers = {
  feriadosGet: feriadosGetDuck.reducer,
  feriadoCreate: feriadoCreateDuck.reducer,
  feriadoDelete: feriadoDeleteDuck.reducer,
};

export {feriadosReducers};
